/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { ModalDelete } from '../../../components/ModalDelete'
import { iCardFeedback } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { Box, Flex, FormControl, Text, useToast } from '@chakra-ui/react'
import { FaFilter, FaPlus } from 'react-icons/fa'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ImgSah } from '../../../components/ImgSah'
import { parseJwt } from '../../../services/token'
import { Paginador } from '../../../components/Paginador'
import LoadingContainer from '../../../components/LoadingContainer'
import { SelectCmp } from '../../../components/SelectCmp'
import { SearchCmp } from '../../../components/SearchCmp'
import { CardFeedback } from './Components/CardFeedback'
import { CheckboxCmp } from '../../../components/CheckboxCmp'

export const GestaoFeedback: React.FC = () => {
  const { pathname, search } = useLocation()
  const nav = useNavigate()

  const params = new URLSearchParams(search)
  const filtro = params.get('filtro')

  const [Feedbacks, setFeedbacks] = useState<iCardFeedback[]>([])
  const toast = useToast()
  const [SearchText, setSearchText] = useState('')
  const [Tipo, setTipo] = useState('')
  const [Filter, setFilter] = useState('0')
  const [FilterStatus, setFilterStatus] = useState(filtro)
  const [IsLoading, setIsLoading] = useState(false)
  const [Pagina, setPagina] = useState(0)
  const [Qtd, setQtd] = useState(0)
  const [Tamanho, setTamanho] = useState(25)
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [FeedbackId, setFeedbackId] = useState('')
  const [ExcluirItensVinculados, setExcluirItensVinculados] = useState(false)

  function getFeedbacks(): void {
    setIsLoading(true)
    appApi.get('FeedbackPersonalizado')
      .then(response => {
        if (response.data.length > 0 || Pagina === 0) {
          setFeedbacks(response.data)
        } else {
          setPagina(0)
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function DeleteFeedback(): void {
    setIsLoading(true)
    appApi.delete(`FeedbackPersonalizado/${FeedbackId}?excluirItensVinculados=${String(ExcluirItensVinculados)}`)
      .then(() => {
        getFeedbacks()
        toast({
          title: 'Feedback excluído com sucesso',
          duration: 4000,
          position: 'top',
          status: 'success'
        })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function OnOpenModalDelete(Id: string): void {
    setFeedbackId(Id)
    setModalDeleteIsOpen(true)
  }

  function OnCloseModalDelete(): void {
    setFeedbackId('')
    setExcluirItensVinculados(false)
    setModalDeleteIsOpen(false)
  }

  useEffect(() => {
    getFeedbacks()
  }, [Pagina, Tamanho])

  return (
    <Body>
      <ModalDelete
        isOpen={ModalDeleteIsOpen}
        message='Você deseja realmente excluir este feedback?'
        onConfirm={DeleteFeedback}
        onRequestClose={OnCloseModalDelete}
        center
      >
        <CheckboxCmp
          isChecked={ExcluirItensVinculados}
          OnChange={setExcluirItensVinculados}
          fontSize='.813rem'
        >
          Excluir também as pesquisas, reuniões e demais itens vinculados a este feedback, inclusive pesquisas que já existiam antes de serem anexadas
        </CheckboxCmp>
      </ModalDelete>
      <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
        <Flex flexDir={'column'}>
          <h1>Gestão de feedbacks</h1>
        </Flex>
        {
          (parseJwt().adm === 'True') && (
            <Flex alignItems={'start'} pt={'.25rem'}>
              <ButtonCmp
                VarColor='Green2'
                leftIcon={<FaPlus size={11}/>}
                onClick={() => nav('Criar')}
              >Criar feedback</ButtonCmp>
            </Flex>
          )
        }
      </Flex>
      <Flex alignItems={'end'} marginBottom='1.5rem' justifyContent={'space-between'}>
        <Flex width={'50%'} gap={'.5rem'}>
          {
            <FormControl width={'16rem'}>
              <SelectCmp OnChange={setFilter} title='Ordenação' value={Filter}>
                <option value={'0'}>Feedback mais recente</option>
                <option value={'1'}>Feedback mais antigo</option>
                <option value={'2'}>A-Z</option>
                <option value={'3'}>Z-A</option>
              </SelectCmp>
            </FormControl>
          }

          <FormControl width={'16rem'}>
            <SelectCmp OnChange={setFilterStatus} title='Tipo de status' value={FilterStatus ?? ''}>
              <Box as={'option'} value={''}>Todos os status</Box>
              <Box as={'option'} value={'0'}>Em elaboração</Box>
              <Box as={'option'} value={'3'}>Selecionando participantes</Box>
              <Box as={'option'} value={'4'}>Gestão de envios</Box>
              <Box as={'option'} value={'5'}>Em andamento</Box>
              <Box as={'option'} value={'6'}>Concluídos</Box>
            </SelectCmp>
          </FormControl>
        </Flex>

        <Flex gap={'.5rem'} justifyContent={'end'}>
          <SearchCmp
            EnterAction={getFeedbacks}
            OnChange={setSearchText}
            placeholder={'Pesquisa'}
          />

          <Flex justifyContent='end' alignItems='center'>
            <ButtonCmp VarColor='Green2' rightIcon={<FaFilter />} onClick={getFeedbacks}>Filtrar</ButtonCmp>
          </Flex>
        </Flex>

      </Flex>

      <Paginador
        next={(e) => setPagina(e)}
        prev={(e) => setPagina(e)}
        tamanho={Tamanho}
        setTamanho={(e) => setTamanho(e)}
        paginaAtual={Pagina}
        qtdElementos={Qtd}
        hideTop={true}
      >
        <LoadingContainer linhas={18} loading={IsLoading}>
          <Flex flexDir={'column'} gap='.5rem'>
            {Feedbacks.length !== 0 &&
              Feedbacks.map((e: iCardFeedback, i) => {
                return (
                  <CardFeedback
                    key={i}
                    feedback={e}
                    onDelete={() => OnOpenModalDelete(e.id)}
                  />
                )
              }
              )
            }
          </Flex>
        </LoadingContainer>
      </Paginador>

      {
        (Feedbacks?.length === 0 && !IsLoading) && (
          <ImgSah entidade={'feedback'} masc>
            {
              (parseJwt().adm === 'True') && (
                <ButtonCmp
                  VarColor='Green2'
                  onClick={() => nav('Criar')}
                >Criar novo feedback</ButtonCmp>
              )
            }
          </ImgSah>
        )
      }
    </Body>
  )
}
